import { Component, input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { GroupResult } from '@progress/kendo-data-query';
import { FormTypeMiniDto } from '@unity/clients';
import { DropdownClickableControlComponent } from '../dropdown-clickable-control/dropdown-clickable-control.component';

@Component({
  selector: 'unity-dropdown-form-types-control',
  imports: [ReactiveFormsModule, DropdownClickableControlComponent],
  templateUrl: './dropdown-form-types-control.component.html',
  styleUrl: './dropdown-form-types-control.component.scss',
})
export class DropdownFormTypesControlComponent {
  public readonly $control = input.required<FormControl>({ alias: 'control' });
  public readonly $selectable = input.required<(GroupResult | FormTypeMiniDto)[]>({ alias: 'selectable' });
  public readonly $displayName = input.required<string>({ alias: 'displayName' });
  public readonly $description = input.required<string>({ alias: 'description' });
}
